import React, { useEffect } from "react";
import { MapContainer, TileLayer, Marker, Popup, useMap } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import { Link } from "react-router-dom";

// Custom earthy marker icon
const cafeIcon = L.divIcon({
  className: "brewfinder-marker",
  html: `<div style="
    width: 30px; height: 30px; border-radius: 50%;
    background: #C05A46; border: 2px solid #F9F6F0;
    display:grid; place-items:center;
    box-shadow: 0 1px 2px rgba(0,0,0,0.15);
    color: #F9F6F0; font-family: 'Manrope', sans-serif;
    font-weight: 600; font-size: 11px;
  ">☕</div>`,
  iconSize: [30, 30],
  iconAnchor: [15, 15],
});

function FitBounds({ cafes }) {
  const map = useMap();
  useEffect(() => {
    if (!cafes || cafes.length === 0) return;
    const bounds = L.latLngBounds(cafes.map((c) => [c.latitude, c.longitude]));
    if (bounds.isValid()) {
      map.fitBounds(bounds, { padding: [40, 40], maxZoom: 11 });
    }
  }, [cafes, map]);
  return null;
}

export default function CafeMap({ cafes = [], focusId, height = "h-[calc(100vh-160px)]" }) {
  const center = cafes.length ? [cafes[0].latitude, cafes[0].longitude] : [39.5, -98.35];

  return (
    <div
      className={`w-full ${height} border border-border rounded-sm overflow-hidden bg-[#F2EBE1]`}
      data-testid="cafe-map"
    >
      <MapContainer
        center={center}
        zoom={4}
        scrollWheelZoom
        style={{ height: "100%", width: "100%" }}
      >
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>, &copy; <a href="https://carto.com/attributions">CARTO</a>'
          url="https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png"
        />
        <FitBounds cafes={cafes} />
        {cafes.map((c) => (
          <Marker
            key={c.id}
            position={[c.latitude, c.longitude]}
            icon={cafeIcon}
            data-testid={`map-marker-${c.id}`}
          >
            <Popup>
              <div className="font-sans" style={{ minWidth: 180 }}>
                <div className="font-serif text-lg text-[#2C1E16] leading-tight">{c.name}</div>
                <div className="text-xs text-[#786B63] mt-1">{c.city} · {c.price_range || "$$"}</div>
                <Link
                  to={`/cafe/${c.id}`}
                  className="inline-block mt-2 text-xs uppercase tracking-wider text-[#C05A46] hover:underline"
                >
                  View details →
                </Link>
              </div>
            </Popup>
          </Marker>
        ))}
      </MapContainer>
    </div>
  );
}
